export default "__VITE_ASSET__BN23G4JF__"